module.exports = __webpack_public_path__ + "static/media/CDs_m_mr.aac8c0ec.jpg";